<template>
  <header class="fixed_detail_header flx">
    <div class="menu flx">
      <h3>{{detail_page_text}}</h3>
    </div>
    <div class="action" v-if="liveShop">
      <router-link :to="{ path: '/live-show'}" replace>
        <span class="badge1">
          <span class="badge_text" v-if="dataLiveShow">LIVE</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            class="tvIcon"
          >
            <g
              fill="none"
              fill-rule="evenodd"
              stroke="#FFF"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              transform="translate(1 1)"
            >
              <rect width="20" height="15" y="5" rx="2" />
              <path d="M15 0l-5 5-5-5" />
            </g>
          </svg>
        </span>
      </router-link>
    </div>
  </header>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "DetailHeader",
  props: {
    detail_header: {
      type: String
    },
    dataLiveShow:{
      type: Boolean
    }
  },
  data() {
    return {
      showBackButton: true,
      detail_page_text: "",
      liveShop: false,
      isLiveShow: false
    };
  },
  watch: {
    detail_header() {
      if (this.$route.name === "ShoppingGame") {
        this.liveShop = true;
        this.detail_page_text = this.$t("shoppingGame");
      } else if (
        this.$route.name === "LiveShowList" ||
        this.$route.name === "TvShop"
      ) {
        this.liveShop = false;
        this.detail_page_text = this.$t("tvShop");
      } else if (this.$route.name === "OrderHistory") {
        this.liveShop = false;
        this.detail_page_text = this.$t("orderHistory");
      } else if (this.$route.name === "CategoryListing") {
        this.liveShop = false;
        this.detail_page_text = this.$t("category");
      } else {
        this.detail_page_text = this.$t("category");
        this.liveShop = false;
      }
    }
  },
  created() {
    if (this.$route.name === "ShoppingGame") {
      this.liveShop = true;
      this.detail_page_text = this.$t("shoppingGame");
    } else if (
      this.$route.name === "LiveShowList" ||
      this.$route.name === "TvShop"
    ) {
      this.liveShop = false;
      this.detail_page_text = this.$t("tvShop");
    } else if (this.$route.name === "OrderHistory") {
      this.liveShop = false;
      this.detail_page_text = this.$t("orderHistory");
    } else if (this.$route.name === "CategoryListing") {
      this.liveShop = false;
      this.detail_page_text = this.$t("category");
    } else {
      this.liveShop = false;
      this.detail_page_text = this.$t("category");
    }
    let [, , dukaanId] = window.location.pathname.split("/");
    if (window.location.pathname === `/dukaan/${dukaanId}/`) {
      this.showBackButton = false;
    }
  },
  methods: {
    sideBar() {
      this.$emit("sideBar");
    },
    goBack() {
      if (this.$cookie.get("version-code") > 57) {
        if (window.history.length == 1) {
          try {
            JSBridgePlugin.gotToHome();
          } catch (err) {
            console.log(err);
          }
        } else {
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    },
    // getLiveShow() {
    //   this.$store
    //     .dispatch({ type: "getCurrentLiveSale" })
    //     .then(data => {
    //       if (
    //         data.data.liveScheduleDTOs.length &&
    //         data.data.liveScheduleDTOs[0].liveStartTimeMilis
    //       ) {
    //         this.isLiveShow = true;
    //       }
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     });
    // }
  },
};
</script>
    